import { getCountryForTimezone } from 'countries-and-timezones';

function getOffsetMinutes(tz) {
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    timeZoneName: 'shortOffset',
  });
  const parts = dtf.formatToParts(new Date());
  const offsetPart = parts.find(p => p.type === 'timeZoneName')?.value;

  const match = offsetPart?.match(/GMT([+-]\d{1,2})(?::?(\d{2}))?/);
  if (!match) return 0;
  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2] || '0', 10);
  return hours * 60 + (hours < 0 ? -minutes : minutes);
}

function getOffsetLabel(minutes) {
  const abs = Math.abs(minutes);
  const hours = Math.floor(abs / 60);
  const mins = abs % 60;
  const sign = minutes >= 0 ? '+' : '-';
  return `${sign}${String(hours).padStart(2, '0')}${String(mins).padStart(2, '0')}`;
}

export function getTimezones() {
  const timezones = Intl.supportedValuesOf('timeZone');

  return timezones.map((tz) => {
    const offsetMinutes = getOffsetMinutes(tz);
    const offsetLabel = getOffsetLabel(offsetMinutes);
    const country = getCountryForTimezone(tz);
    return {
      text: tz,
      value: tz,
      offset: offsetLabel,
      countryCode: country ? country.id : 'US'
    };
  });
}

export function getUTCHourForLocalHour(timeZone, localHour) {
  const now = new Date();

  // Create a local time string like "2025-05-20T03:00:00"
  const localTimeStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}T${String(localHour).padStart(2, '0')}:00:00`;

  // Convert this string as if it's in the given time zone
  const localDate = new Date(
    new Intl.DateTimeFormat('en-US', {
      timeZone,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(new Date(localTimeStr))
  );

  // The Date constructor above loses time zone context, so use the original string
  const zonedDate = new Date(localTimeStr + getOffsetStringFromMinutes(getOffsetMinutes(timeZone)));

  return zonedDate.getUTCHours();
}

function getOffsetStringFromMinutes(minutes) {
  const sign = minutes >= 0 ? '+' : '-';
  const abs = Math.abs(minutes);
  const h = String(Math.floor(abs / 60)).padStart(2, '0');
  const m = String(abs % 60).padStart(2, '0');
  return `${sign}${h}:${m}`;
}

export function getLocalHourForUTCHour(timeZone, utcHour) {
  const now = new Date();

  // Build a UTC time on today's date using the given hour
  const utcDate = new Date(Date.UTC(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    utcHour,
    0,
    0
  ));

  // Convert that UTC time to the local time in the specified timeZone
  const localTimeString = utcDate.toLocaleString('en-US', {
    timeZone,
    hour: '2-digit',
    hour12: false
  });

  return parseInt(localTimeString, 10);
}